import { render, staticRenderFns } from "./QuestionSingleChoiceVueComponent.vue?vue&type=template&id=7ed7318e&"
import script from "./QuestionSingleChoiceVueComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionSingleChoiceVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionSingleChoiceVueComponent.vue?vue&type=style&index=0&id=7ed7318e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports